import React from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage, injectIntl} from "react-intl";
import $ from "jquery";

import {
  removeFromCart,
  changeMessageBoxState,
  toggleUserPopup,
  setQtActiveCategory,
  changeActivePartRelatedItemIndex,
  toggleSelectionWindow,
  toggleSelectionFeatureInfo,
  toggleBathroomVisualizerOpen, setCameFromPage
} from "../../actions/actionFunctions";
import {
  detectComplexLaborCartItem,
  getFeatureIsLocked,
  getFeatureUnit, getTotalPrice,
  toFixedFeatureCost,
  toFixedPrice
} from "../../misc/helpers";
import CommonFeatureItemsMethods from "../visComponents/commonFeatureItemsMethods";
import PriceInput from "./priceInput";
import {getCurrentLayout} from "../appLayout";
import {checkIfInCatProperty} from "../../misc/displayLogic";
import NoteEditor from "./noteEditor";
import ActionTypes from "../../misc/actionTypes";
import {cartItemInterface} from "./cartItemInterface";
import FeatureName from "../visComponents/featureName";
import {setActiveQuoteIndex} from "../../actions/roomsFunctions";
import Config from "../../config";
import {setCartItemEditFeature} from "../../actions/shoppingCartFunctions";
import {getPriceWithIncluded} from "../../misc/priceFunctions";
// import {setActionAfterVisualizerTypeIsChanged} from "../../actions/serverFunctions";
import {deleteCartItemsFromSQFTCalcData, updateCurrentQuote} from "../../misc/quotesFunctions";
import ShoppingCartItemsBundledProducts from "./shoppingCartItemsBundledProducts";
import {SQFT_FEATURES} from "../sqft/constants";
import ShoppingCartItemsListItemEditButton from "./shoppingCartItemsListItemEditButton";
// import {COUNTERTOP_GROUP} from "../kvComponent/core/constants";
// import {MEASURE_UNITS} from "../sqft/constants";

class ShoppingCartItemsListItem extends CommonFeatureItemsMethods {

  static propTypes = {
    cartItem: PropTypes.shape(cartItemInterface).isRequired,
    editFeatureGroupClick: PropTypes.func.isRequired,
    isBundleChild: PropTypes.bool,
  }

  state = {
    editorVisible: false,
    editorCanRender: true
  }

  componentDidMount() {
    $(window).on(ActionTypes.UPDATE_ALL_ITEMS, this.handleRefresh);
  }

  componentWillUnmount() {
    $(window).off(ActionTypes.UPDATE_ALL_ITEMS, this.handleRefresh);
    window.removeEventListener('click', this.handleWrapperBlur);
  }

  shouldComponentUpdate(nextProps) {
    return !nextProps.showAssignQuotePopup;
  }

  handleRefresh = () => {
    this.setState({
      editorVisible: false,
      editorCanRender: false
    }, () => {
      this.setState({
        editorCanRender: true
      })
    });
    this.forceUpdate();
  }

  handleRemoveClick = () => {
    const {cartItem, fabricatorData} = this.props;
    this.props.changeMessageBoxState({
      visible: true,
      message: {
        id: "shoppingCart.fetureInCartRemovePopupQuestion",
        featureName: cartItem.cartFeature.getFeatureName()
      },
      buttons: [{
        text: "shoppingCart.fetureInCartRemovePopupNo",
        color: "blue",
        click: () => {
          this.props.changeMessageBoxState({visible: false});
        }
      }, {
        text: "shoppingCart.fetureInCartRemovePopupYes",
        color: "green",
        click: async () => {
          this.props.removeFromCart(cartItem);
          this.props.changeMessageBoxState({visible: false});
          if (fabricatorData.settings.useCategorySwitching) {
            await updateCurrentQuote(cartItem.currentQuote, undefined, false);
          }
          deleteCartItemsFromSQFTCalcData([cartItem]).then(r => void r);
        }
      }]
    });
  };

  handleEditClick = () => {
    const {cartItem} = this.props;
    this.props.editFeatureGroupClick(null, cartItem);
    this.props.setCartItemEditFeature(cartItem);
    setTimeout(() => {
      this.props.setCartItemEditFeature(cartItem); // in case it was erased by wizard change
    }, 0)
  };

  handleAddNoteClick = () => {
    this.setState({
      editorVisible: !this.state.editorVisible
    }, () => {
      setTimeout(() => {
        this.state.editorVisible
          ? window.addEventListener('click', this.handleWrapperBlur)
          : window.removeEventListener('click', this.handleWrapperBlur)
      }, 0)
    })
  };

  handleWrapperBlur = (e) => {
    const disallowClasses = [".product-note", ".link--note"];
    if (this.state.editorVisible && !disallowClasses.some(cls => e.target.closest(cls))) {
      this.setState({
        editorVisible: false
      })
    }
  };

  onNoteSave = () => {
    this.handleAddNoteClick();
  };

  toggleUserPopup = () => {
    this.props.toggleUserPopup({
      userPopupOpened: true
    })
  };

  render() {

    const layout = getCurrentLayout();
    const editingPriceAvailable = Config.isDevMode();

    const isMobile = this.props.windowWidth < 991;
    const {fabricatorData, cartItem, activeQuoteIndex, intl, cartItems, isBundleChild, isSlabPricingEnabled} = this.props;
    const fabricatorSettings = fabricatorData.settings;

    if (this.props.showUnlockCalculations && !this.props.showCartItems.includes(cartItem.id)) {
      return false
    }
    const subPartName = cartItem.cartFeature.getParent ? cartItem.cartFeature.getParent().partName : "";
    let showPrice = false;
    let priceTotal = null;
    const priceIsLocked = getFeatureIsLocked(cartItem.cartFeature);
    if (fabricatorSettings.showPricing && !fabricatorData.hideCheckoutBreakdownCost && !fabricatorData.hidePricesFromUser) {
      const isComplexMultipliedUsed = detectComplexLaborCartItem(cartItem) && getTotalPrice().multipliedCostUsed;
      if (isComplexMultipliedUsed || cartItem.displayFakePrice === 0) {
        priceTotal = null
      } else {
        // not sure if we need displayFakePrice?
        // priceTotal = cartItem.displayFakePrice ? cartItem.displayFakePrice :
        //   toFixedFeatureCost(cartItem.cartFeature, cartItem.quantity, cartItem.fromQtCategory, true, cartItem, cartItem.shouldUseSlabPricing);
        const shouldUseSlabPricing = cartItem.partId === SQFT_FEATURES.slabs && isSlabPricingEnabled;
        priceTotal = toFixedFeatureCost(
          cartItem.cartFeature,
          cartItem.quantity,
          cartItem.fromQtCategory,
          true,
          cartItem,
          shouldUseSlabPricing,
          cartItem.currentQuote
        );
      }
      showPrice = !priceIsLocked;
    }
    // const isEditable = !layout.qtCategories || cartItem.relatedProductParent ||(
    //   layout.qtCategories.some(qtCategory => qtCategory.subParts && qtCategory.subParts.some(qtCatSubPart => {
    //     return qtCatSubPart.part.partId === cartItem.cartFeature.partId
    //   }))
    // );
    const unit = getFeatureUnit(cartItem.cartFeature, intl, fabricatorData, cartItem.quantity, cartItem);
    const isEditable = !["Slab", "Slabs"].includes(unit) && !isBundleChild; // always editable except slab, all logic is inside switchToFeatureInfo method
    const getItemTitle = () => {
      let itemTitle;
      if (cartItem.cartFeature.inCatProperties) {
        itemTitle = checkIfInCatProperty(cartItem.cartFeature, "inCatName", cartItem.cartFeature.getFeatureName(), cartItem.fromQtCategory)
      }

      return itemTitle ? itemTitle : <FeatureName feature={cartItem.cartFeature}/>
    }

    const hasBundleProducts = cartItems.some(cItem => cItem.bundleParentId === cartItem.id);

    return (
      <li className={"scart-block__product" + (cartItem.cartFeature.notesList[activeQuoteIndex] ? " scart-block__product--with-note" : "")}>
        {cartItem.subGroupTitle ? (
          <h4 className="bold ml-075 pl-075 scart-block__title-room">{cartItem.subGroupTitle}</h4>
        ) : null}
        <div className={"scart-block__list-item"
        + (!(showPrice && !isMobile) ? " scart-block__list-item--locked" : "")
        + (cartItem.isMinimumCharge ? " scart-block__list-item--minimum-charge" : "")
        + (!showPrice && !priceIsLocked ? " scart-block__list-item--no-price" : "")}>
          <div className="scart-block__list-item-text">
            <h4 className="scart-block__list-item-text-title">
              {subPartName && !layout.qtCategories ? subPartName + " - " : null}
              { getItemTitle() }
            </h4>
            {cartItem.cartFeature?.dbFeature?.sku && !fabricatorSettings.hideSku ? (
              <span className="product-info__price-model" style={isMobile ? null : {margin: "-8px 0 4px 0"}}>
                <FormattedMessage id="quotingTool.featureInfo.skuNumber"/> {cartItem.cartFeature.dbFeature.sku}
              </span>
            ) : null}
            {cartItem.description ? (
              <p className="scart-block__list-item-text-description"
                 dangerouslySetInnerHTML={{__html: cartItem.description}}/>
            ) : null}
            {cartItem.isMinimumCharge && !cartItem.isMinimumChargeItems ? null : (
              <div className="scart-block__list-item-text-price">
                {showPrice && isMobile ? (
                  <span className="scart-block__list-item-text-price-number">
                    {getPriceWithIncluded(priceTotal, cartItem.cartFeature, fabricatorData, intl.messages)}
                  </span>
                ) : null}
                {priceIsLocked && isMobile ? (
                  <span className="scart-block__list-item-text-price-locked" onClick={this.toggleUserPopup}>
                    <FormattedMessage id="shoppingCart.featureInCartPricingLocked"/>
                  </span>
                ) : null}
                {fabricatorSettings.useCategorySwitching && cartItem.partId === "room" ? null : (
                  <span className="scart-block__list-item-text-quantity">
                    {unit}: {
                      toFixedPrice(parseFloat(cartItem.displayFakeQuantity) === cartItem.displayFakeQuantity
                        ? cartItem.displayFakeQuantity
                        : cartItem.quantity, fabricatorSettings.useDifferentCurrencies)
                    }
                  </span>
                )}
              </div>
            )}
          </div>
          {isMobile && !cartItem.isMinimumCharge && !cartItem.isAddedFromDisplayLogic ? (
            <div className="scart-block__list-item-buttons">
              <button className={"ui-smallbutton ui-smallbutton--note"
              + (this.state.editorVisible ? " ui-smallbutton--active" : "")}
                      onClick={this.handleAddNoteClick}/>
              {isEditable ? <ShoppingCartItemsListItemEditButton handleEditClick={this.handleEditClick}
                                                                 cartItem={cartItem}/> : null}
              <button className="ui-smallbutton ui-smallbutton--remove" onClick={this.handleRemoveClick}/>
            </div>
          ) : cartItem.isMinimumCharge || cartItem.isAddedFromDisplayLogic ? null : (
            <div className="scart-block__list-item-buttons scart-block__list-item-buttons--desktop">
                <span className="link link--blue link--note" onClick={this.handleAddNoteClick}>
                  {cartItem.cartFeature.notesList[activeQuoteIndex]
                    ? <FormattedMessage id="shoppingCart.featureInCartEditNoteLink"/>
                    : <FormattedMessage id="shoppingCart.featureInCartAddNoteLink"/>}
                </span>
              {isEditable ? <ShoppingCartItemsListItemEditButton handleEditClick={this.handleEditClick}
                                                                 cartItem={cartItem}/> : null}
              <span className="link link--red" onClick={this.handleRemoveClick}>
                  <FormattedMessage id="shoppingCart.featureInCartDeleteLink"/>
                </span>
            </div>
            )
          }
          {!isMobile ? (
            <div className="shoppingcart-block__list-item-total">

              {showPrice
                ? editingPriceAvailable
                  ? <PriceInput priceTotal={+priceTotal} cartItem={cartItem}/>
                  : (<span className="price">
                      {getPriceWithIncluded(priceTotal, cartItem.cartFeature, fabricatorData, intl.messages)}
                    </span>)
                : null}
              {priceIsLocked ? (
                <span className="price price--locked" onClick={this.toggleUserPopup}>
                <FormattedMessage id="shoppingCart.featureInCartPricingLocked"/>
              </span>
              ) : null}
            </div>
          ) : null}
        </div>
        {this.state.editorCanRender && !cartItem.isMinimumCharge && !cartItem.isAddedFromDisplayLogic ? (
          <NoteEditor cartItem={cartItem}
                      dbFeatureId={cartItem.cartFeature.dbFeature.id}
                      editorVisible={this.state.editorVisible}
                      closeEditor={this.onNoteSave}/>
        ) : null}
        {hasBundleProducts ? <ShoppingCartItemsBundledProducts parentCartItem={cartItem}
                                                               editFeatureGroupClick={this.props.editFeatureGroupClick}/> : null}
      </li>
    )
  }
}

const mapStateToProps = (store) => {
  const {allWizardsValues, wizardList} = store.wizardState;
  return {
    cartItems: store.cartState.cartItems,
    isPhoneNumberValidated: store.userState.isPhoneNumberValidated,
    windowWidth: store.serverState.windowWidth,
    fabricatorData: store.fabricatorState,
    showUnlockCalculations: store.unlockCalculationsState.showUnlockCalculations,
    showCartItems: store.unlockCalculationsState.showCartItems,
    activeQuoteIndex: store.quotesState.activeQuoteIndex,
    wizardList,
    allWizardsValues,
    showAssignQuotePopup: store.assignQuoteState.showAssignQuotePopup,
    isSlabPricingEnabled: store.sqftSlabState.isSlabPricingEnabled,
  };
};

const mapDispatchToProps = {
  removeFromCart,
  changeMessageBoxState,
  toggleUserPopup,
  setQtActiveCategory,
  /*** CommonFeatureItemsMethods needs next methods: ***/
  changeActivePartRelatedItemIndex,
  toggleSelectionWindow,
  toggleSelectionFeatureInfo,
  toggleBathroomVisualizerOpen,
  setCameFromPage,
  /*** CommonFeatureItemsMethods needs methods end ***/
  setActiveQuoteIndex,
  setCartItemEditFeature
}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(ShoppingCartItemsListItem)
)
